import React from 'react'
import { useTranslation } from 'react-i18next'

import { Box, DialogContent } from '@material-ui/core'
import Typography from 'ui/components/typography'
import useStyles from './styles'

const PhoneLimit = () => {
  const { t } = useTranslation()
  const classes = useStyles()

  return (
    <DialogContent className={classes.dialogContent}>
      <Box mb={3}>
        <Typography variant="h3" color="primary">
          {t('common.phoneLimitTitle')}
        </Typography>
      </Box>
      <Box mb={2}>
        <Typography variant="basic" color="textPrimary">
          {t('common.phoneLimitDescription')}
        </Typography>
      </Box>
    </DialogContent>
  )
}

export default PhoneLimit
